import { FC, useState } from 'react';
import { InfoWindow, Polygon } from '@react-google-maps/api';
import { typeCoords } from '@monorepo/models';

type propsType = {
    color: string | undefined;
    onClick: () => void;
    path: typeCoords[];
    strokeColor?: string;
    windowLabel?: string;
};

export const HTHInteractiveMapMapBlockPolygon: FC<propsType> = ({ color, onClick, path, strokeColor, windowLabel }) => {
    const [hover, setHover] = useState(false);

    return (
        <>
        <Polygon
            path={path}
            onClick={onClick}
            onMouseOver={() => setHover(true)}
            onMouseOut={() => setHover(false)}
            options={{
                clickable: true,
                fillColor: color,
                fillOpacity: hover ? 0.9 : 0.7,
                strokeColor: strokeColor || color,
                strokeOpacity: 1,
                strokeWeight: 3,
                zIndex: 1,
            }}
            // @ts-ignore
            style={{ transition: 'fill 0.3s, stroke 0.3s' }}
        />
        {hover && windowLabel &&
            <InfoWindow position={path[0]} options={{ headerContent: windowLabel }}>
                <></>
            </InfoWindow>
        }
        </>
    );
}
